import {WarriorClass} from "@/store/level/types";


export class CardInfo{
    cardType!: CardType;
    count!: number;
    description!: string;
    isActive!: boolean;
    comment!: string
}

export enum CardNews {
    GIFT_3_ELEPHANT = "GIFT_3_ELEPHANT",
}

export enum CardType {
    ELEPHANT = "ELEPHANT",
    SNAKE = "SNAKE",
    EAGLE = "EAGLE",
    MOUSE = "MOUSE",
    EVOLUTION_UNIVERSAL = "EVOLUTION_UNIVERSAL",
    EVOLUTION_ACE = "EVOLUTION_ACE",
    EVOLUTION_LUCK = "EVOLUTION_LUCK",
    EVOLUTION_CHAOS = "EVOLUTION_CHAOS",
    EVOLUTION_DEATH = "EVOLUTION_DEATH",
    EVOLUTION_DRYAD = "EVOLUTION_DRYAD",
    EVOLUTION_FACELESS = "EVOLUTION_FACELESS",
    EVOLUTION_GORGON = "EVOLUTION_GORGON",
    EVOLUTION_HUMAN = "EVOLUTION_HUMAN",
    EVOLUTION_INKUB = "EVOLUTION_INKUB",
    EVOLUTION_KOSCHEY = "EVOLUTION_KOSCHEY",
    EVOLUTION_MANTICORE = "EVOLUTION_MANTICORE",
    EVOLUTION_NUN = "EVOLUTION_NUN",
    EVOLUTION_PHOENIX = "EVOLUTION_PHOENIX",
    EVOLUTION_RIDER = "EVOLUTION_RIDER",
    EVOLUTION_SHADOW = "EVOLUTION_SHADOW",
    EVOLUTION_SPHINX = "EVOLUTION_SPHINX",
    EVOLUTION_SUKKUB = "EVOLUTION_SUKKUB",
    EVOLUTION_WITCH = "EVOLUTION_WITCH",
    EVOLUTION_DRUID = "EVOLUTION_DRUID"
}


export class CardState {
    activeCard: CardType | null = null;
}

export interface EvolutionInfo {
    availableClasses: WarriorClass[];
    comment: string;
}
